<mat-drawer-container>
  <mat-drawer position="end"
    mode="side"
    [opened]="true"
    class="list-density-settings-3">
    <mat-nav-list>
      @if (!isPrestatiePage) {
        <div class="client-info">
          <div class="header mat-small">Zone</div>
          @if (selectedClientDienst) {
            <div class="mat-small">{{selectedClientDienst.getZoneId() | zahZone:zones}}</div>
          }
        </div>
        <div class="client-info">
          <div class="header mat-small">Adres</div>
          <div class="mat-small">
            {{client.getAdres().getStraat()}} {{client.getAdres().getNummer()}} {{client.getAdres().getBus() ? 'bus ' + client.getAdres().getBus() : ''}}
            ,
            {{client.getAdres().getPostcode()}} {{client.getAdres().getGemeente()}}
          </div>
        </div>
        <mat-divider></mat-divider>
        <div mat-subheader class="header mat-small">Ga naar</div>
        <div class="client-info-navigatie">
          <mat-list-item (click)="onMeldingenClicked()">
            <mat-icon matListItemIcon
              fontSet="material-icons-outlined">
              contact_mail
            </mat-icon>
            <div matListItemTitle>Meldingen</div>
          </mat-list-item>
          @if (user.isRegioverantwoordelijke()) {
            <mat-list-item
              (click)="onPrestatieClicked()">
              <mat-icon matListItemIcon
                fontSet="material-icons-outlined">
                fact_check
              </mat-icon>
              <div matListItemTitle>Prestaties</div>
            </mat-list-item>
          }
          <mat-list-item
            (click)="onSignaalkaartClicked()">
            <mat-icon matListItemIcon
              fontSet="material-icons-outlined">
              assignment
            </mat-icon>
            <div matListItemTitle>Signaalkaarten</div>
          </mat-list-item>
          @if (user.isRegioverantwoordelijke()) {
            <mat-list-item
              (click)="onWijzigClientClicked()">
              <mat-icon matListItemIcon
                fontSet="material-icons-outlined">
                edit
              </mat-icon>
              <div matListItemTitle>Cliënt wijzigen</div>
            </mat-list-item>
          }
          @if (user.isRegioverantwoordelijke() || user.isTherapeut()) {
            <mat-list-item
              (click)="onClientFicheClicked()">
              <mat-icon matListItemIcon
                fontSet="material-icons-outlined">
                description
              </mat-icon>
              <div matListItemTitle>Cliëntfiche</div>
            </mat-list-item>
          }
        </div>
        <mat-divider></mat-divider>
      }

      @if (!diensten.isEmpty()) {
        <div mat-subheader class="header mat-small">Dienst</div>
        <mat-list-item class="dienst no-list-item-highlight"
          disableRipple>
          <mat-form-field matListItemTitle appearance="fill">
            <mat-label></mat-label>
            <mat-select [(ngModel)]="selectedDienstId"
              (selectionChange)="changeDienst($event)">
              @for (dienst of diensten.getDiensten(); track dienst) {
                <mat-option [value]="dienst.getId()">
                  {{dienst.getLabel()}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-list-item>
        <mat-divider></mat-divider>
        @if (selectedDienst) {
          @for (taakType of selectedDienst.getTaakTypes(); track taakType; let isLast = $last) {
            <div mat-subheader class="header mat-small">{{taakType | titlecase}}</div>
            @for (categorie of selectedDienst.getCategorieenByType(taakType); track categorie) {
              <mat-list-item
                (click)="selectCategory(taakType, categorie)"
                [class.active]="isSelected(taakType, categorie)">
                <div matListItemTitle>{{categorie.getLabel()}}</div>
              </mat-list-item>
            }
            @if (!isLast) {
              <mat-divider></mat-divider>
            }
          }
        }
      }
    </mat-nav-list>
  </mat-drawer>

  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>

</mat-drawer-container>
